import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tools" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("face")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_menu = _resolveComponent("ui-menu")!
  const _component_ui_menu_anchor = _resolveComponent("ui-menu-anchor")!
  const _component_ui_top_app_bar = _resolveComponent("ui-top-app-bar")!

  return (_openBlock(), _createBlock(_component_ui_top_app_bar, {
    class: "app-bar",
    "content-selector": ".app-content",
    "nav-id": "menu"
  }, {
    toolbar: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ui_menu_anchor, {
          absolute: "",
          position: "middle right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ui_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_icon, {
                  class: "icon icon--white",
                  size: _ctx.iconSize
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["size"])
              ]),
              _: 1
            }),
            _createVNode(_component_ui_menu, {
              position: "TOP_START",
              modelValue: _ctx.open,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.open) = $event)),
              onSelected: _ctx.onSelected,
              items: _ctx.menuItems
            }, null, 8, ["modelValue", "onSelected", "items"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}